import { Box, Text } from '@betterment/samba-react';

import ResendInvites from './ResendInvites';

import { Referral } from '../data';

export type Props = {
  title: string;
  referralData: Referral[];
};

const InvitationListItem: React.FC<Props> = ({ title, referralData }) => {
  return (
    <Box key={title} css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
      <Text as="p" css={{ fontSize: 'fontSize.50' }}>
        {title}
      </Text>
      {referralData.map((referral, index) => {
        return (
          <Box key={referral.email}>
            <Text
              as="p"
              key={referral.email}
              color="text.weak"
              css={{
                marginBottom: 'space.0',
              }}
            >
              {referral.email}
            </Text>
            {referral.status === 'prompt' && (
              <ResendInvites referralInviteId={referral.personalReferralInviteId || ''} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default InvitationListItem;
